<template>
  <div class="flex flex-col my-auto">
    <div class="flex mx-auto mb-6">
      <div @click="cardClick('sub-concept-one')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-lg 2xl:text-2xl leading-tight text-white">ART PRODUCTION <br> PROCESS & COSTS</h4>
      </div>
      <div @click="cardClick('sub-concept-two')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">MUSIC <br> CONCEPTS</h4>
      </div>
      <div @click="cardClick('sub-concept-three')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">STREAM <br>ARCHITECTURE</h4>
      </div>
      <div @click="cardClick('sub-concept-four')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
        <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">HALL OF <br> ETERNITY</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConceptIndex",
  methods:{
    cardClick(cardName){
      Event.$emit('clickedCard', cardName);
    }
  }
}
</script>

<style lang="css" scoped>
.circles{
  width: 12rem;
  height: 12rem;
}

@media (min-width: 1024px){

  .circles{
    width: 10rem;
    height: 10rem;
  }

}

@media (min-width: 1280px){

  .circles{
    width: 12rem;
    height: 12rem;
  }

}

@media (min-width: 1367px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 1500px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 1550px){

  .circles{
    width: 14rem;
    height: 14rem;
  }

}

@media (min-width: 2000px){

  .circles{
    width: 16rem;
    height: 16rem;
  }

}
</style>
